const WORDS_PER_MINUTE = 200;

export const countWords = (text: string): number => text.split(/\s+/).filter(Boolean).length;

/** Whole minutes to read `text` at 200 words per minute, never less than 1. */
export const readingTimeMinutes = (text: string): number =>
  Math.max(1, Math.ceil(countWords(text) / WORDS_PER_MINUTE));

export const formatReadingTime = (text: string): string => `${readingTimeMinutes(text)} min read`;
